import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import {
  ChooseWebsitePageActions,
  LoginPageActions,
  LoginSettingsActions,
} from './login-settings.actions';
import { LoginSettings } from '@lyceo/homi/login/util-models';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';

export const LOGIN_SETTINGS_FEATURE_KEY: string = 'loginSettings';

export interface LoginSettingsState {
  website: string | undefined;
  settings: LoginSettings | undefined;
  settingsCallState: CallState;
}

export const initialLoginSettingsState: LoginSettingsState = {
  website: undefined,
  settings: undefined,
  settingsCallState: LoadingState.INIT,
};

const reducer: ActionReducer<LoginSettingsState, Action> = createReducer(
  initialLoginSettingsState,
  on(
    ChooseWebsitePageActions.websiteChosen,
    (state, { website }): LoginSettingsState => ({
      ...state,
      website,
      settingsCallState: LoadingState.LOADING,
    }),
  ),
  on(
    LoginSettingsActions.getLoginSettings,
    (state): LoginSettingsState => ({
      ...state,
      settingsCallState: LoadingState.LOADING,
    }),
  ),
  on(
    LoginSettingsActions.getLoginSettingsSuccess,
    (state, { settings }): LoginSettingsState => ({
      ...state,
      settings,
      settingsCallState: LoadingState.LOADED,
    }),
  ),
  on(
    LoginSettingsActions.getLoginSettingsFailure,
    (state, { error }): LoginSettingsState => ({
      ...state,
      settingsCallState: { errorMsg: error.message },
    }),
  ),
  on(
    ChooseWebsitePageActions.websiteLogout,
    LoginPageActions.clearWebsite,
    (state): LoginSettingsState => ({
      ...state,
      website: undefined,
    }),
  ),
);

export function loginSettingsReducer(
  state: LoginSettingsState | undefined,
  action: Action,
): LoginSettingsState {
  return reducer(state, action);
}
